<template>
  <img :src="bannerInfo.thumbnail | resizeThumbnail({width: 750, height: 130}) "
       alt="" class="single-banner-image" v-if="bannerInfo"
       @click.prevent="clickEvent"
  >
</template>

<script>
import { resizeThumbnail } from '@/common/image.filter'
import { getEventListByType } from '@/common/util/event.util'
import { get } from 'lodash'
import { bannerLink } from '@/common/util/common'
import { AnalizeService } from '@/common/api/api.service'
export default {
  name: 'SingleBannerItem',
  filters: { resizeThumbnail },
  props: {
    bannerInfo: {
      type: Object
    }
  },
  methods: {
    clickEvent () {
      const { onNavigationEvent, onClickEvent } = getEventListByType(this.bannerInfo.event_list)
      const url = get(onNavigationEvent, 'url', '')
      if (onClickEvent) {
        AnalizeService.sendLogList([onClickEvent]).then(() => {
          bannerLink(url)
        })
      } else {
        bannerLink(url)
      }
    }
  }
}
</script>

<style scoped>
.single-banner-image{
  display: block;
  width: 100%;
  max-width : 375px;
  margin: 0 auto
}

</style>
